import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/core/api.service';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { ErrCode, PermissionActions } from 'src/app/shared/models';

@Component({
  selector: 'app-upgrade-plan',
  templateUrl: './upgrade-plan.component.html',
  styleUrls: ['./upgrade-plan.component.scss']
})
export class UpgradePlanComponent implements OnInit {
  protected errCode: ErrCode;
  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private log: LoggerService,
    private userService: UserService
  ) {}

  ngOnInit() {
    if(!this.userService.checkPermission(PermissionActions.MANAGE_BILLING)) this.errCode = new ErrCode(8401);
    else this.redirectToCheckout();
  }

  protected redirectToCheckout = async () => {
    try {
      const result = await this.apiService.execute('createupgradecheckout', {
        item_id: this.route.snapshot?.queryParams?.item_id,
        coupon_id: this.route.snapshot?.queryParams?.coupon_id,
        term: this.route.snapshot?.queryParams?.term,
        qty: this.route.snapshot?.queryParams?.qty,
        trial: this.route.snapshot?.queryParams?.trial,
      }) as any;
      window.location.replace(result.chargebee_checkout_url);
    } catch(ex) {
      this.log.error(ex);
      this.errCode = ErrCode.fromException(ex);
    }
  }

}
